// src/components/common/Navigation.jsx
import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  ShoppingCart,
  Clock,
  LayoutDashboard,
  Package,
  Users,
  Ruler,
  Store,
  Tag,
  ArrowLeftRight,
  ShoppingBag,
  Settings,
  UserCheck,
  BarChart2,
  ArrowUpCircle
} from 'lucide-react';

import { useApp } from '../../context/AppContext';
import { translations } from '../../utils/translations';

const Navigation = () => {
  const { language, currentUser } = useApp();
  const t = translations[language];

  const navItems = [
    {
      path: '/pos',
      icon: ShoppingCart,
      label: t.pos || '收银台',
      roles: ['admin', 'manager', 'cashier']
    },
    {
      path: '/shift',
      icon: Clock,
      label: t.shift || '班次管理',
      roles: ['admin', 'manager', 'cashier']
    },
    {
      path: '/dashboard',
      icon: LayoutDashboard,
      label: t.dashboard || '数据看板',
      roles: ['admin', 'manager']
    },
    {
      path: '/sales-report',
      icon: BarChart2,
      label: language === 'en' ? 'Sales Report' : language === 'km' ? 'របាយការណ៍លក់' : '销售报表',
      roles: ['admin', 'manager']
    },
    {
      path: '/products',
      icon: Package,
      label: t.products || '商品管理',
      roles: ['admin', 'manager']
    },
    {
      path: '/categories',
      icon: Tag,
      label: t.categories || '分类管理',
      roles: ['admin']
    },
    {
      path: '/units',
      icon: Ruler,
      label: t.units || '单位管理',
      roles: ['admin']
    },
    {
      path: '/employees',
      icon: Users,
      label: t.employees || '员工管理',
      roles: ['admin', 'manager']
    },
    {
      path: '/stores',
      icon: Store,
      label: '门店管理',
      roles: ['admin'],
      store_type: 'headquarters'
    },
    {
      path: '/stock-transfers',
      icon: ArrowLeftRight,
      label: '库存划拨',
      roles: ['admin', 'manager']
    },
    {
      path: '/online-orders',
      icon: ShoppingBag,
      label: '线上订单',
      roles: ['admin', 'manager']
    },
    {
      path: '/customers',
      icon: UserCheck,
      label: '客户管理',
      roles: ['admin', 'manager']
    },
    {
      path: '/shop-settings',
      icon: Settings,
      label: '商家设置',
      roles: ['admin'],
      store_type: 'headquarters'
    },
    {
      path: '/usdt-withdraw',
      icon: ArrowUpCircle,
      label: 'USDT提币审核',
      roles: ['admin'],
      store_type: 'headquarters'
    }
  ];

  const visibleNavItems = navItems.filter(item =>
    item.roles.includes(currentUser?.role) &&
    (!item.store_type || item.store_type === currentUser?.store_type)
  );

  return (
    <nav className="bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex space-x-1 overflow-x-auto">
          {visibleNavItems.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) => `
                  flex items-center px-4 py-3 text-sm font-medium transition-colors whitespace-nowrap
                  ${isActive
                    ? 'text-blue-600 border-b-2 border-blue-600 bg-blue-50'
                    : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
                  }
                `}
              >
                <Icon className="w-5 h-5 mr-2" />
                {item.label}
              </NavLink>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;